export default "__VITE_ASSET__6zYCJ7Ss__"